import * as React from 'react';
import * as classNames from 'classnames';
import {StatelessComponent} from 'react';
import './styles.sass';

interface IVideoSettingsSectionProps {
  children?: any;
  center?: boolean;
  column?: boolean;
  middle?: boolean;
}

export const VideoSettingsSection: StatelessComponent<IVideoSettingsSectionProps> = ({
  children,
  center,
  column,
  middle,
}) => {
  const sectionClassNames = classNames('video-settings-section', {
    'video-settings-section_column': column,
    'video-settings-section_middle': middle,
    'video-settings-section_center': center,
  });

  return (
    <div className={sectionClassNames}>
      {children}
    </div>
  );
};
